module.exports = __webpack_public_path__ + "static/media/bg_stu_red.a2eeedc2.png";